import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import Register from '../components/Register/Register';

function RegisterPage() {
  const [logoOk, setLogoOk] = useState(true);

  return (
    <div className="mx-auto" style={{ maxWidth: '620px' }}>
      <div className="auth-brand">
        {logoOk && (
          <img
            src={process.env.PUBLIC_URL + '/biotrop-icon.png'}
            alt="Biotrop"
            className="brand-logo-lg mb-2"
            onError={() => setLogoOk(false)}
          />
        )}
        <span className="auth-brand-name">BIOTROP</span>
        <span className="auth-brand-tagline">Soluções em Tecnologia Biológica</span>
      </div>

      <Card>
        <Card.Body className="p-3 p-md-4">
          <Register />
        </Card.Body>
      </Card>
    </div>
  );
}

export default RegisterPage;
